import { UseMutationDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { FeatureFlagRepository } from '@front/repository/Api/FeatureFlag';
import type { IFeatureFlagRepository } from '@front/repository/Api/FeatureFlag/interface';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { featureFlagQueryKeys } from './queryKeys';

const repository = new FeatureFlagRepository();

export const _update = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: IFeatureFlagRepository.Update.Params) => {
      return repository.update(params, { signal: signalToTimeout(DEFAULT_TIMEOUT.MUTATION) });
    },
    onSuccess: (updated, variables) => {
      queryClient.setQueryData(featureFlagQueryKeys.detail(variables.projectId), updated);
      void queryClient.invalidateQueries({ queryKey: featureFlagQueryKeys.detail(variables.projectId) });
    },
    ...UseMutationDefaultOptions,
  });
};
